import { useState, type ReactNode, type MouseEvent } from "react";
import { CreationContext, type CreationRequest } from "./CreationContext";
import { ContactCreateSheet } from "../contacts/ContactCreateSheet";
import { CompanyCreateSheet } from "../companies/CompanyCreateSheet";
export function CreationProvider({ children }: { children: ReactNode }) {
  const [request, setRequest] = useState<CreationRequest>();
  const capture = (event: MouseEvent<HTMLDivElement>) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    )
      return;
    const anchor = (event.target as Element).closest("a");
    if (anchor?.hasAttribute("data-related-contact")) return;
    const href = anchor?.getAttribute("href");
    const match = href?.match(/^#?\/(contacts|companies)\/create$/);
    if (!match) return;
    event.preventDefault();
    event.stopPropagation();
    setRequest({ resource: match[1] as CreationRequest["resource"] });
  };
  return (
    <CreationContext.Provider value={setRequest}>
      <div className="contents" onClickCapture={capture}>
        {children}
      </div>
      <ContactCreateSheet
        open={request?.resource === "contacts"}
        defaultValues={request?.defaults}
        onOpenChange={(open) => {
          if (!open) setRequest(undefined);
        }}
      />
      <CompanyCreateSheet
        open={request?.resource === "companies"}
        onOpenChange={(open) => {
          if (!open) setRequest(undefined);
        }}
      />
    </CreationContext.Provider>
  );
}
